import * as React from "react";
import {
  Button,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Route, Switch, Link as RouterLink } from "react-router-dom";
import GuestRegister from "./Register";
import GuestLogin from "./Login";
import GuestResetPassword from "./ResetPassword";
import GuestResetPasswordNew from "./ResetPassword/New";
import { useProvidedTranslations } from "contexts";
import logoBlue from "assets/logoBlue.png";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  logo: {
    maxWidth: "100%",
    marginBottom: theme.spacing(4),
  },
}));

const Guest = () => {
  const formatMessage = useProvidedTranslations();
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="sm">
      <div className={classes.paper}>
        <img className={classes.logo} src={logoBlue} alt="Plexus logo" />
        <Switch>
          <Route exact path="/register">
            <GuestRegister />
          </Route>
          <Route exact path="/login">
            <GuestLogin />
          </Route>
          <Route exact path="/reset-password">
            <GuestResetPassword />
          </Route>
          <Route exact path="/reset-password-new">
            <GuestResetPasswordNew />
          </Route>
          <Route path="/">
            <Typography component="h1" variant="h5">
              {formatMessage("app.guest.title")}
            </Typography>
            <Typography component="p" variant="body1">
              {formatMessage("app.guest.body")}
            </Typography>
            <Grid spacing={2} container className={classes.form}>
              <Grid item xs={12}>
                <Button
                  component={RouterLink}
                  to="/login"
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {formatMessage("app.guest.buttons.login")}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  component={RouterLink}
                  to="/register"
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {formatMessage("app.guest.buttons.register")}
                </Button>
              </Grid>
            </Grid>
          </Route>
        </Switch>
      </div>
    </Container>
  );
};

export default Guest;
